import React, {useState, useEffect} from 'react';
import EventView from "./EventView"
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getAllEvents} from "../KnowledgeBankAction";
import {useParams} from "react-router-dom";

function Event(props) {
    const [eventPageState, setEventPageState] = useState({
        events: [],
        isApiInProgress: false,
        apiErrorMessage: '',
    });

    const {id} = useParams();

    useEffect(() => {
        setEventPageState(prevState => ({...prevState, isApiInProgress: true}));
        getAllEvents()
            .then(res => {
                if (res.success) {
                    setEventPageState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        events: res.data,
                    }));
                } else {
                    setEventPageState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        apiErrorMessage: res.__error,
                    }));
                }
            });
    }, []);

    return (
        <EventView {...props}
                   {...eventPageState}
                   eventId={id}
        />
        );
}


const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    isMobileDevice: state.appState.deviceInfo.isMobileDevice,
    isLGView: state.appState.deviceInfo.isLGView,
    isXLView: state.appState.deviceInfo.isXLView,
    isXSView: state.appState.deviceInfo.isXSView,
    searchEventText: state.appState.searchEventText,
});

export default connect(mapStateToProps, {})(withRouter(Event));
